import React from 'react'

export const KEITH = (
  <>
    <p>
      Keith is a Financial Services and FinTech Executive, Founder and Chief
      Executive Officer of San Diego-based FinTech Company Chalice Network, a
      member benefit organization for independent wealth advisors that delivers
      a fully integrated suite of technology tools, products, and services
      through a single sign-on shared services technology platform – Chalice
      Advisor Exchange™. He has three decades of executive leadership and
      financial services experience. Prior to founding Chalice Network™ he was
      Founder &amp; CEO of Innovation Equity Partners, CEO of Capital Guardian
      Securities and First Allied Securities. Keith also served as Senior
      Executive for Wachovia Securities, GE Capital, and Prudential
      Investments.; and has built a reputation as a Business Acceleration
      Executive.
    </p>
    <p>
      Keith is the author of Do Well by Doing Good: The Complete Guide to
      Charitable Remainder Trusts and is a certified planned giving specialist.
      He holds FINRA Series 7, 24, 63, 65 registrations and is a graduate of the
      Securities Industry Institute at University of Pennsylvania’s Wharton
      Business School. Keith was the founder and Chairman of the Wealth Advisor
      Institute, past President of the Institute of Investment Management
      Consultants Association Chapters, and Chairman of the Membership Committee
      for the Investment Management Consulting Association.
    </p>
    <p>
      Keith lives in San Diego, CA with his wife, Catherine, and their two sons.
      He served honorably in the US Marine Corps and is a recipient of the
      Presidential Service Award from President Ronald Reagan for his loyal
      service aboard Marine One.
    </p>
  </>
)

export const DEREK = (
  <>
    <p>
      Derek Bruton is the President of Chalice Network. Derek brings a unique
      combination of RIA, RIA custodian, and B/D experience to the Members he
      serves at CFN. A proven strategic and sales leader in the financial
      services industry for 29 years, Derek has served in executive positions
      with leading RIA custodians such as Charles Schwab, TD Ameritrade, and LPL
      Financial. He has led the recruiting of over 10,000 financial advisors in
      his career and has assisted with the strategy and growth of over 20,000
      advisor businesses. Derek frequently speaks at financial services industry
      events and is often quoted in financial publications.
    </p>
    <p>
      Derek graduated from Stanford University and has completed executive
      business management coursework at Harvard University. He lives in San
      Diego, CA with his wife, Helen, and their two girls. Derek played
      collegiate basketball for Stanford and professional basketball in Japan.
      He has FINRA licenses 7,8, 24, and 63. He serves on the board of directors
      of the Invest in Others Charitable Foundation and is involved in other
      philanthropic efforts in the San Diego community.
    </p>
  </>
)

export const TIM = (
  <>
    <p>
      Tim has spent his career in startups.  He cofounded a geolocation mobile
      application which received funding from Qualcomm Labs. He cofounded a
      bitcoin wallet and key management software company which makes managing
      your crypto assets easier than ever. He helped grow and scale Succession
      Link to 40k+ members. Now he is the CTO of Chalice Network. He also likes
      to dabble in bioinformatics and has coauthored papers on applying machine
      learning to detecting Lassa fever biomarkers. He has a Masters of Computer
      Science from California State University of San Marcos.
    </p>
    <p>
      Tim lives in Poway, CA with his wife, Chrissy, and their two children and
      one more on the way. He likes to hike, play guitar and spend time with his
      family.
    </p>
  </>
)

export const HOME_META_DESCRIPTION = `
  Want to take your business to the next level? Join a thriving member-benefit
  organization for small to mid-sized independent business owners & financial
  advisors.
`

export const ABOUTUS_DESCRIPTION = `
  Our Mission Is Simple. Serving You. Meet the Chalice Team. A team dedicated
  to growing your business and helping you better serve your clients.
`

export const CONTACT_DESCRIPTION = `
  Want to take your business to the next level? Join a thriving member-benefit
  organization for small to mid-sized independent business owners & financial
  advisors.
`

export const EVENTS_DESCRIPTION = `
  Chalice hosts impactful, educational (and free!) webinars throughout the year
  for independent business owners and advisors. View more here.
`

export const LOGIN_DESCRIPTION = `
  Thank you for being a valued member. Login here.
`

export const MARKETPLACE_TITLE = `Marketplace | Benefits, Business Development, CRM | Chalice`

export const MARKETPLACE_DESCRIPTION = `
  Explore our marketplace to find the best services for your business. We've
  done the heavy lifting for you to gain exclusive access to unique technology
`

export const BLOG_TITLE = `Blog | Benefits, Business Development, CRM | Chalice`

export const BLOG_DESCRIPTION = `
  Explore our blog to find out what's new.
`

export const NEWS_DESCRIPTION = `
  Read about Chalice in Forbes, Wealth Management, Investor News and more.
`

export const PRESS_DESCRIPTION = `
  Chalice Network - News &amp; Press Chalice is leading change in the
  wealth advisory industry. Read about Chalice in Forbes, Wealth Management,
  Investor News and more.
`

export const PRICING_DESCRIPTION = `
  Are you looking to take your business to the next level? We have several
  membership plans, depending on your business needs. Choose a plan that works
  for you
`

export const SIGNUP_DESCRIPTION = `
  Gain access to a premier
  member-benefit organization that empowers small to mid-sized independent
  business owners.
`

export const SIGNUP_SUCCESS_DESCRIPTION = `
  Welcome and congratulations on joining the network!
`

export const SIGNUP_RC_DESCRIPTION = `
  Membership Signup made signing up for
  advisor services easy. Gain access to a premier member-benefit organization
  that empowers small to mid-sized independent business owners.
`

export const SIGNUP_PLANS_DESCRIPTION = `
  Join! Gain access to financial advisor solutions, including our most
  popular, and save big today.
`
